export default "__VITE_ASSET__B7aL7hQ3__"